import React from 'react';
import MappedTotals from './MappedTotals';

const New = ({ subcategory }) => {
  return <div></div>;
};

export default New;
